export default {
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description':
    "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'global#facet_empty_text': 'Nessun elemento disponibile',
  'readmore#label': 'Mostra tutto',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Leggi meno',
  'search#works_total': '<strong>{ total }</strong> Opere',
  'search#works_total_1': '<strong>{ total }</strong> Opera',
  'search#works_total_0': 'Nessuna Opera',
  'search#people_total': '<strong>{ total }</strong> Persone',
  'search#people_total_1': '<strong>{ total }</strong> Persona',
  'search#people_total_0': 'Nessuna Persona',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#placeholder_query_general': 'Ricerca libera',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#placeholder_query-name': 'Cerca un nome',
  'search#placeholder_profession': 'Cerca un ruolo',
  'search#placeholder_profession_specific': 'Cerca per ruolo (ricerca libera)',
  'search#header_authors': 'Autori',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#header_voyage': 'Viaggi',
  'search#header_sex': 'Genere',
  'search#header_profession': 'Ruolo',
  'search#header_events': 'Eventi storici',
  'search#header_years': 'Anni',
  'search#header_places': 'Luoghi',
  'search#header_place_name': 'Luoghi',
  'search#header_institution': 'Istituto',
  'search#facets_title': 'Filtra i risultati',
  'search#filters_title': 'Filtri attivi:',
  'search#sort_title': 'Ordine',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Ordine alfabetico (A→Z)',
  'search#sort_desc': 'Ordine alfabetico (Z→A)',
  'search#resultsamount': 'Risultati per pagina',
  'search#fallback_text':
    'La tua ricerca non ha dato risultati. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#fallback_button': 'Resetta la ricerca',
  'search#ko_text':
    'Oops, abbiamo riscontrato un errore nella ricerca. Prova a cambiare i parametri oppure a resettare la ricerca cliccando sul pulsante sottostante.',
  'search#ko_button': 'Resetta la ricerca',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_accordion': 'Viaggi in Cina',
  'resource#metadata_size': 'Dimensioni',
  'resource#primary-bibliography': 'Fonti primarie',
  'resource#secondary-bibliography': 'Fonti secondarie',
  'resource#collection_voyages': 'Viaggi',
  'resource#collection_people': 'Persone collegate',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#date': 'data',
  'search#bibliographies_total':
    '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1':
    '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#placeholder_query': 'Ricerca libera',
  'search#placeholder_authors': 'Cerca un autore',
  'search#placeholder_place_name': 'Cerca un luogo',
  'search#placeholder_query_years': 'Cerca un anno',
  'search#title_bibliographies': 'Bibliografia',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#title_biographies': 'Vite antiche',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#title_iconographies': 'Vite antiche',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#title_tools': 'Materiali e strumenti',
};
